"use client";
import { makeStyles, tokens, Button } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ClientRoutes } from "../models/ClientRoutes";
import { SkanskaColorTokens } from "../style/colors";
import { Breakpoints } from "../style/styles";
import {
  publishedDocumentMetadataMigrationEnabled,
  publishedMediaMetadataMigrationEnabled,
} from "../config/features";

const useClasses = makeStyles({
  root: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    padding: tokens.spacingVerticalM,
  },
  adminTitle: {
    textAlign: "center",
    marginBottom: "20px",
  },
  container: {
    display: "grid",
    flexDirection: "column",
    gap: "40px",
    gridTemplateColumns: "1fr 1fr 1fr",
    ...Breakpoints.medium({
      gridTemplateColumns: "1fr",
    }),
  },
  adminInfo: {
    backgroundColor: SkanskaColorTokens.color_secondary_dim_white,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    paddingBottom: "15px",
    padding: tokens.spacingVerticalL,
  },
});

function SystemAdminPage() {
  const classes = useClasses();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <h1 className={classes.adminTitle}>{t("systemAdminPage")}</h1>
      <div className={classes.container}>
        <div className={classes.adminInfo}>
          <h2>{t("cacheManagement.title")}</h2>
          <p>{t("cacheManagement.description")}</p>
          <Button onClick={() => navigate(ClientRoutes.SystemAdminCache)}>
            {t("cacheManagement.link")}
          </Button>
        </div>
        {publishedDocumentMetadataMigrationEnabled && (
          <div className={classes.adminInfo}>
            <h2>{t("publishedDocumentMetadataMigration.title")}</h2>
            <p>{t("publishedDocumentMetadataMigration.description")}</p>
            <Button
              onClick={() =>
                navigate(ClientRoutes.PublishedDocumentMetadataMigration)
              }
            >
              {t("publishedDocumentMetadataMigration.manage")}
            </Button>
          </div>
        )}
        {publishedMediaMetadataMigrationEnabled && (
          <div className={classes.adminInfo}>
            <h2>{t("publishedMediaMetadataMigration.title")}</h2>
            <p>{t("publishedMediaMetadataMigration.description")}</p>
            <Button
              onClick={() =>
                navigate(ClientRoutes.PublishedMediaMetadataMigration)
              }
            >
              {t("publishedMediaMetadataMigration.manage")}
            </Button>
          </div>
        )}
        <div className={classes.adminInfo}>
          <h2>{t("imageFileMigration.title")}</h2>
          <p>{t("imageFileMigration.description")}</p>
          <Button onClick={() => navigate(ClientRoutes.ImageFileMigration)}>
            {t("imageFileMigration.manage")}
          </Button>
        </div>
        <div className={classes.adminInfo}>
          <h2>{t("imageMetadataUpdater.title")}</h2>
          <p>{t("imageMetadataUpdater.description")}</p>
          <Button onClick={() => navigate(ClientRoutes.ImageMetadataUpdater)}>
            {t("imageMetadataUpdater.manage")}
          </Button>
        </div>
        <div className={classes.adminInfo}>
          <h2>{t("reindexManagement.title")}</h2>
          <p>{t("reindexManagement.description")}</p>
          <Button onClick={() => navigate(ClientRoutes.ReindexJobMonitoring)}>
            {t("reindexManagement.link")}
          </Button>
        </div>
        <div className={classes.adminInfo}>
          <h2>{t("globalSearchSettingsHeader")}</h2>
          <p>{t("searchSettingsManagement.description")}</p>
          <Button
            onClick={() => navigate(ClientRoutes.SystemAdminSearchSettings)}
          >
            {t("searchSettingsManagement.link")}
          </Button>
        </div>
        <div className={classes.adminInfo}>
          <h2>{t("documentManagement.title")}</h2>
          <p>{t("documentManagement.description")}</p>
          <Button
            onClick={() => navigate(ClientRoutes.SystemAdminDocumentManagement)}
          >
            {t("documentManagement.link")}
          </Button>
        </div>
        <div className={classes.adminInfo}>
          <h2>{t("linkManagement.title")}</h2>
          <p>{t("linkManagement.description")}</p>
          <Button
            onClick={() => navigate(ClientRoutes.SystemAdminLinkManagement)}
          >
            {t("linkManagement.link")}
          </Button>
        </div>
        <div className={classes.adminInfo}>
          <h2>{t("utilityLinksAdminPage")}</h2>
          <p>{t("utilityLinksAdminPageDescription")}</p>
          <Button
            onClick={() => navigate(ClientRoutes.SystemAdminUtilityLinks)}
          >
            {t("utilityLinksManage")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SystemAdminPage;
